<form class="form-inline my-2 my-lg-0">
	<div class="input-group w-100" *ngIf="searchFilter$ | async as searchFilters">
		<ng-container>
			<div
				[ngClass]="searchFilters.length < 4 ? 'd-none d-lg-block' : 'd-none'"
				class="input-group-prepend inline-filter"
				*ngFor="let searchFilter of searchFilters; let i = index"
			>
				<span
					class="input-group-text bg-secondary text-light border-0"
					[ngClass]="i === searchFilters.length - 1 ? '' : ''"
				>
					<app-search-filter [searchFilter]="searchFilter"></app-search-filter
					><span class="ms-1" (click)="removeSearchFilter(searchFilter)" ngbTooltip="Remove"
						>&times;</span
					>
				</span>
			</div>
			<div
				[ngClass]="searchFilters.length < 4 ? 'd-block d-lg-none' : 'd-block'"
				*ngIf="searchFilters.length > 0"
				class="input-group-prepend"
				ngbDropdown
				placement="bottom-start"
			>
				<button
					ngbDropdownToggle
					class="btn btn-secondary dropdown-toggle rounded-start border-0"
					type="button"
					id="dropdownMenuButton"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
				>
					Filters ({{ searchFilters.length }})
				</button>
				<div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuButton">
					<button ngbDropdownItem class="dropdown-item" *ngFor="let searchFilter of searchFilters">
						<app-search-filter [searchFilter]="searchFilter" [expand]="true"></app-search-filter
						><span class="ms-1" (click)="removeSearchFilter(searchFilter)" ngbTooltip="Remove"
							>&times;</span
						>
					</button>
					<div class="dropdown-divider"></div>
					<a ngbDropdownItem class="dropdown-item" (click)="clearSearchFilters()">Remove All</a>
				</div>
			</div>
		</ng-container>
		<input
			id="main-search"
			accesskey="s"
			#itemInput
			#itemInputDirective="ngbTypeahead"
			[ngbTypeahead]="searchFilterTypeahead.results"
			(selectItem)="addSearchFilter($event); itemInput.value = ''"
			[resultTemplate]="rt"
			(click)="searchFilterTypeahead.updateTerm(itemInput.value)"
			(keydown)="typeaheadKeydown(itemInputDirective, $event)"
			[popupClass]="'max-height-80'"
			class="form-control"
			type="search"
			[placeholder]="placeholder"
			[container]="'body'"
			aria-label="Search"
		/>
		<div
			*ngIf="!control"
			class="input-group-append"
			ngbDropdown
			display="dynamic"
			placement="bottom-end"
		>
			<button
				ngbDropdownToggle
				ngbTooltip="Search Tools"
				container="body"
				class="btn btn-secondary dropdown-toggle"
				type="button"
				id="dropdownMenuButton"
				data-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="false"
			></button>
			<div
				ngbDropdownMenu
				class="dropdown-menu"
				aria-labelledby="dropdownMenuButton"
				style="min-width: 225px"
			>
				<ng-container *ngIf="recentSearchFilter$ | async as recentSearchFilters; else noRecent">
					<ng-container
						*ngIf="
							stripSearchFilters(recentSearchFilters, searchFilters).reverse() as recentFilters
						"
					>
						<h6 *ngIf="recentFilters.length > 0" class="dropdown-header">Recent Filters</h6>
						<button
							ngbDropdownItem
							type="button"
							(click)="addSearchFilter({ preventDefault: null, item: searchFilter })"
							*ngFor="let searchFilter of recentFilters | slice : 0 : 5"
							class="dropdown-item"
						>
							<app-search-filter [searchFilter]="searchFilter" [expand]="true"></app-search-filter>
						</button>
						<div *ngIf="recentFilters.length > 0" class="dropdown-divider"></div>
					</ng-container>
				</ng-container>
				<ng-template #noRecent>
					<h6 class="dropdown-header">No Recent Filters</h6>
					<p class="px-4">Recent search filters will appear here.</p>
					<div class="dropdown-divider"></div>
				</ng-template>
				<ng-container *ngIf="savedSearch$ | async as savedSearches; else noSaved">
					<h6 *ngIf="savedSearches.length > 0" class="dropdown-header">Saved Searches</h6>
					<button
						ngbDropdownItem
						type="button"
						(click)="setSearchFilters(savedSearch.filters)"
						*ngFor="let savedSearch of savedSearches"
						class="dropdown-item"
					>
						{{ savedSearch.name
						}}<span class="ms-1" (click)="removeSavedSearch(savedSearch)" ngbTooltip="Remove"
							>&times;</span
						>
					</button>
					<div *ngIf="savedSearches.length > 0" class="dropdown-divider"></div>
				</ng-container>
				<ng-template #noSaved>
					<h6 class="dropdown-header">No Saved Searches</h6>
					<p class="px-4">Saved searches will appear here. Enter search criteria to get started.</p>
					<div class="dropdown-divider"></div>
				</ng-template>
				<ng-container>
					<div *ngIf="searchFilters.length > 0" class="form-group px-3">
						<div class="input-group input-group-sm">
							<input
								#searchName
								class="form-control form-control-sm"
								placeholder="Save search as..."
							/>
							<div class="input-group-append">
								<button
									type="button"
									(click)="saveSearch(searchFilters, searchName.value)"
									class="btn btn-sm btn-secondary"
								>
									Save
								</button>
							</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</div>
</form>
<ng-template #rt let-r="result" let-t="term">
	<ngb-highlight
		[attr.data-resultGroup]="r.resultGroup"
		class="ms-5 px-5"
		[class.font-italic]="!r.isActive"
		[result]="r.name"
		[term]="t"
	></ngb-highlight>
</ng-template>
